import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const app = createApp(App);

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Your Car LLC";
  next();
});

app.use(router).mount("#app");
